module.exports = __webpack_public_path__ + "img/thunderforest-atlas.cbf03697.jpg";